/**
 * Created by marlon.jerez on 12/07/2016.
 */

declare const jQuery:any;


export class navBar{

	constructor(){
		var self = this;
		jQuery(".MainNav .SubNav-button").each(function(){
			var button = jQuery(this);
			var target = jQuery(button.data("activates"));
			if(target.length){
				button.click(function(e){
					e.preventDefault();
					self.toogleVisivility(target);
					self.toogleArrow(button);
				})
			}
		});

		//init sidenav
		jQuery(".button-collapse").sideNav();
		//close sidenab
		jQuery('.close-sidenav , .side-nav .sub-btn a').click(()=>{
			jQuery("#sidenav-overlay").click();
		});
		this.initMenusPage();
	}


	toogleVisivility(subMenu:JQuery){
		var main = jQuery("#main");
		if(subMenu.hasClass("state_hidden")){
			//hides any other subMenu that might be visible
			jQuery(".SubNav").removeClass("state_visible").addClass("state_hidden");
			//show subMenu
			subMenu.removeClass("state_hidden").addClass("state_visible");
			main.addClass("menu_active");
		}else if(subMenu.hasClass("state_visible")){
			//hide subMenu
			subMenu.removeClass("state_visible").addClass("state_hidden");
			main.removeClass("menu_active");
		}
	}

	toogleArrow(button:JQuery){
		if(button.hasClass("state_active")){
			//hide this
			button.removeClass("state_active");
		}else{
			//hide all
			jQuery(".SubNav-button").removeClass("state_active");
			//show this
			button.addClass("state_active");
		}
	}


	initMenusPage(){
		var self = this;
		if(typeof window.IS_MENU_PAGE != "undefined" && window.IS_MENU_PAGE){
			window.onload = function () {
				setTimeout(function () {
					jQuery(".menusPage").addClass("loaded");
					jQuery('.scrollspy').scrollSpy();
					self.storeName();
				},0);
			}
		}
	}

	storeName(){
		if(typeof window.STORE_MENU_NAME != "undefined" ){
			jQuery(".navStoreName").text(window.STORE_MENU_NAME).addClass("active");
		}
	}

}
